import { styled } from 'goober';
import Checkbox from 'preact-material-components/Checkbox';

const KfsTncContainer = styled('div')`
  display: flex;
  margin: 10px auto 24px;
  max-width: 360px;
  .tncText {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: #000000;
    margin-top: 8px;
  }
  .tncLink {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: #1a73e8;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const KfcTnc = (props) => {
  return (
    <KfsTncContainer>
      <Checkbox
        id='tnc-check-box'
        checked={props.checked}
        onChange={() => {
          props.setChecked();
        }}
      />
      <div className='tncText'>
        I agree to{' '}
        <span className='tncLink'>
          Key Fact Statement and Terms & Conditions
        </span>{' '}
        of the loan agreement and{' '}
        <span className='tncLink'>Terms & Conditions of InstaCred</span>
      </div>
    </KfsTncContainer>
  );
};

export default KfcTnc;



// WEBPACK FOOTER //
// ./components/checkoutWidget/KfsTnc.js